import { render } from "./SuccessScreen.vue?vue&type=template&id=28ab8bad"
import script from "./SuccessScreen.vue?vue&type=script&lang=js"
export * from "./SuccessScreen.vue?vue&type=script&lang=js"

import "./SuccessScreen.vue?vue&type=style&index=0&id=28ab8bad&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__